import { defineStore } from "pinia";
import { computed, ref } from "vue";


export const usePermissionsStore = defineStore('roles', () => {

  const getPermissions = () => {
    try {
      return JSON.parse(localStorage.getItem('authorities')) || [];
    } catch {
      return [];
    }
  };

  // State
  const permissions = ref(getPermissions());
  // const permissions = ref(JSON.parse(localStorage.getItem('authorities') || "[]"));

  // Getters
  const hasPermission = (permission) => computed(() => permissions.value.includes(permission));
  const hasAnyPermission = (requiredPermissions) => computed(() =>
    requiredPermissions.some(p => permissions.value.includes(p))
  );
  const hasAllPermissions = (requiredPermissions) => computed(() =>
    requiredPermissions.every(p => permissions.value.includes(p))
  );

  // Actions
  const updatePermissions = () => {
    permissions.value = JSON.parse(localStorage.getItem('authorities') || []);
  };

  const reset = () => {
    permissions.value = [];
  };

  return {
    permissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    updatePermissions,
    reset,
  };
})